import {
    ISeriesPrimitivePaneRenderer,
    ISeriesPrimitivePaneView,
    SeriesPrimitivePaneViewZOrder
} from 'lightweight-charts'
import type DrawingBase from './drawing.base'
import DrawingPaneRenderer from './drawing.paneRenderer'


export type DrawingPaneViewOptions = {
    id: string,
    drawing: DrawingBase<any, any, any>
}

class DrawingPaneView implements ISeriesPrimitivePaneView {
    drawing: DrawingBase<any, any, any>
    id: string

    constructor(options: DrawingPaneViewOptions) {
        this.drawing = options.drawing
        this.id = options.id
    }

    zOrder(): SeriesPrimitivePaneViewZOrder {
        return 'top'
    }

    renderer(): ISeriesPrimitivePaneRenderer | null {
        return new DrawingPaneRenderer({
            drawing: this.drawing,
            id: this.id
        })
    }
}


export default DrawingPaneView